import { EmojiInput } from './EmojiInput';
import { EmojiConsts, EmojiSpecs } from './EmojiSpecs';
import { EmojiSuggest } from './EmojiSuggest';
export { EmojiConsts } from './EmojiSpecs';
const EmojiExtension = (builder, options) => {
    builder.use(EmojiSpecs, options).use(EmojiInput, options).use(EmojiSuggest, options);
};
export const Emoji = Object.assign(EmojiExtension, EmojiConsts);
